import { ThemeUIStyleObject } from 'theme-ui';

export const containerStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: ['0.75rem', '1rem', '1rem'], // mobile, tablet, desktop
  padding: ['0.75rem', '1rem', '1rem'], // mobile, tablet, desktop
  borderBottom: '1px solid',
  borderBottomColor: 'neutral/200',
  backgroundColor: 'neutral/000',
};

export const userInfoStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
  gap: '0.125rem', // 2px
  overflow: 'hidden', // Enable text truncation
};
